<template>
    <LayoutBase>
        <header id="header" class="justify-left">
            <div class="container">
                <div class="">
                    <h1 class="h1">{{ person.name }}</h1>
                </div>
                <div class="actions">
                </div>
            </div>
            <nav class="container">
                <!-- <ul>
                    <li>
                        <a href="#">Posts</a>
                    </li>
                    <li>
                        <a href="#">Groups</a>
                    </li>
                </ul> -->
            </nav>
        </header>

        <div class="container profile">
            <div class="panel">
                <div class="grid">
                    <div class="col-md-8">
                        <div class="profile__item" v-for="(val, key) in person.fields">
                            <span class="h4">{{key}}</span> 
                            <div>{{val}}</div>
                        </div>
                    </div>

                    <div class="col-4">
                    </div>
                </div>
            </div>

        </div>
    </LayoutBase>
</template>

<script>
    // const Uppy = require('@uppy/core');
    // const XHRUpload = require('@uppy/xhr-upload');
    // const Dashboard = require('@uppy/dashboard');
    //const Url = require('@uppy/url');
    // const MediaLibrary = require('../../../lib/MediaLibrary');

    import LayoutBase from '../../layouts/LayoutBase';
    import { mapState, mapGetters } from 'vuex';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                editing: null,
                showEditButton: null,
                person: {},
                isAdmin: window.user_can.admin
            }
        },
        computed: {
            introFormatted: function () {
                return '<p>' + this.person.intro.replace(/\n([ \t]*\n)+/g, '</p><p>')
                 .replace('\n', '<br />') + '</p>';
            },
            experienceFormatted: function () {
                return '<p>' + this.person.work_experience.replace(/\n([ \t]*\n)+/g, '</p><p>')
                 .replace('\n', '<br />') + '</p>';
            },
            ...mapState({
                loggedInUser: state => state.auth.user,
            }),
        },
        created() {
            this.getUser();
        },
        mounted() {
        
        },
        methods: {
            getUser() {
                axios.get('/api/people/contact-list/' + this.$route.params.list + '/contact/' + this.$route.params.contact).then((response) => {
                    this.person = response.data;
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>